import { FormLabel, forwardRef, InputProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { PasswordInput } from "../PasswordInput/PasswordInput";
import { WithFormControl, WithFormControlProps } from "../WithFormControl";

export interface PasswordInputFieldProps extends InputProps {
  label: ReactNode;
  rootProps?: WithFormControlProps;
}

export const PasswordInputField = forwardRef<PasswordInputFieldProps, "input">(
  ({ label, rootProps, ...props }, ref) => {
    return (
      <WithFormControl variant="floating" {...rootProps}>
        <PasswordInput
          variant="flushed"
          placeholder=" "
          label={<FormLabel>{label}</FormLabel>}
          {...props}
          ref={ref}
        />
      </WithFormControl>
    );
  }
);
